<script>
import { mapGetters, mapActions } from 'vuex'
import PaymentForm from '@/components/PaymentForm/PaymentForm.vue'
import { getCurrency } from '@/utils/format'
import { getPciDssPaymentTokens, createAdsCreditPayment } from '@/api/ads'
import { formatNumber } from '@/views/ads/utils/index'

export default {
  name: 'PciDssPaymentForm',
  components: {
    PaymentForm,
  },
  computed: {
    ...mapGetters('ads', ['paymentData']),
    currency() {
      return this.paymentData?.billingAddress?.currency || ''
    },
    amount() {
      return formatNumber(this.paymentData?.topUpData?.cost?.amount || 0)
    },
    payButtonText() {
      return this.$t('ads_top_up_pay_now')
    },
  },
  created() {
    if (!this.paymentData) {
      this.$router.replace('/ads/ads-credit/top-up')
    }
  },
  methods: {
    ...mapActions('ads', ['setPaymentData']),
    onCancel() {
      this.isKeepPaymentData = true
      this.$router.replace('/ads/ads-credit/top-up')
    },
    async onPay({ cardNumber, expiryMonth, expiryYear, cvv, paymentData }) {
      // Get PCI DSS payment tokens
      const pciDssPaymentTokensRes = await getPciDssPaymentTokens({
        number: cardNumber.replace(/\s/g, ''),
        expiryMonth: Number(expiryMonth),
        expiryYear: Number(expiryYear),
        cvv: cvv,
      })

      const { token, bin } = pciDssPaymentTokensRes.data

      const { billingAddress, topUpData } = paymentData

      // Create ads credit payment
      const adsCreditPaymentRes = await createAdsCreditPayment({
        cardToken: token,
        amount: topUpData.cost.amount,
        bin,
        billingAccountId: billingAddress.accountId,
      })

      const { data } = adsCreditPaymentRes.data

      // Redirect
      if (data && data.redirectUrl) {
        window.location.href = data.redirectUrl
      }
    },
    getCurrency,
  },
}
</script>

<template>
  <PaymentForm
    :on-cancel="onCancel"
    :on-pay="onPay"
    :pay-button-text="payButtonText"
    :keep-payment-data="true"
  />
</template>
